import React, { useState } from 'react';

import { useQuery } from 'react-query';

import { getAccessToken } from 'utils/authentication';
import { addZeroToOneDecimal } from 'utils/numbersShowingUtils';

import { GetUpgradeSubscriptionDetails } from 'services/payments';
import { products } from 'constants/products.const';

import Spinner from '@core/components/spinner/Spinner';
import ActionButton from '@core/components/actionbutton/ActionButton';

import RadioSelectedIcon from '@core/assets/icons/radio-selected.svg';
import RadioDeselectedIcon from '@core/assets/icons/radio-deselected.svg';
import { EmptyWalletRemove } from 'iconsax-react';

import classes from './ChangePlanModal.module.scss';




const ChangePlanModal = ({ changePlanHandler, upgradeSubscriptionIsLoading }) => {
    const { data, isLoading } = useQuery(['change-plan-details', getAccessToken()], () => GetUpgradeSubscriptionDetails());
    const [selectedPlan, setSelectedPlan] = useState();

    return (
        <div className={classes['wrapper']}>
            {data && !isLoading && (
                <>
                    <h3>
                        Upgrade your plan
                    </h3>
                    <div className="row pb-3">
                        <div className="col-lg-7 col-12">
                            <div className={classes['change-info']}>
                                <h4>
                                    Available plans to upgrade
                                </h4>
                                <div className='d-flex flex-column gap-3'>
                                    {data?.data?.upgrade_options.map((option) => (
                                        <div
                                            key={option.plan_name}
                                            className={classes['option-wrapper']}
                                            onClick={() => setSelectedPlan(option)}
                                        >
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div style={{ color: products.find(product => product.name === option.plan_id)?.color }} className='d-flex align-items-center gap-2'>
                                                    {selectedPlan?.plan_id === option.plan_id ? <RadioSelectedIcon /> : <RadioDeselectedIcon />}
                                                    {products.find(product => product.name === option.plan_id)?.title}
                                                </div>
                                                <div className={classes['price']}>
                                                    <div>
                                                        {option.discounted_price && (
                                                            <span className={classes['real-price']}>
                                                                <sup className={classes.time}>{option.currency.symbol}</sup>
                                                                {option.price}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div>
                                                        {option.discounted_price ? (
                                                            <span>
                                                                <sup className={classes.time}>{option.currency.symbol} </sup>
                                                                <strong>{option.discounted_price}</strong>
                                                                <span className={classes.time}>/mo</span>
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                <sup className={classes.time}>{option.currency.symbol} </sup>
                                                                <strong>{option.price} </strong><span className={classes.time}>/mo</span>
                                                            </span>
                                                        )}
                                                    </div>
                                                    {/* <strong> {option.currency.symbol}
                                                        {option.price}</strong>/mo */}
                                                </div>
                                            </div>
                                            <div className={classes['line']}></div>
                                            <div className='d-flex  align-items-start gap-2 mt-2 pe-3'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ flexShrink: 0 }}>
                                                    <path d="M3 9L6.99529 12.75L15 5.25" stroke="#91BC60" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                                <p>{products.find(product => product.name === option.plan_id)?.description}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-12 pt-3 pt-lg-0">
                            <div className={classes['current-plan-wrapper']}>
                                <h5>Current Plan</h5>
                                <div className={classes['current-plan']}>
                                    {data?.data?.current_plan_name || 'plan name'}
                                </div>
                            </div>
                            <div className={classes['cancel-wrapper']}>
                                <div className='d-flex align-items-center gap-2'>
                                    <EmptyWalletRemove size={20} color={'#403F3F'} variant='TwoTone' />
                                    <h5>Cancel anytime.</h5>
                                </div>
                                <p>
                                    You’ll always keep access until the end of your current period.
                                </p>
                                <div className={classes['due-amount']}>
                                    <span>You will pay today:</span>
                                    <div className='d-flex justify-content-between align-items-center mt-3'>
                                        <span>Due Today</span>
                                        <span>{selectedPlan?.currency.symbol}{selectedPlan?.payable_price || selectedPlan?.amount_due || '0'}</span>
                                    </div>
                                </div>
                            </div>

                            <p className={classes['charge-alert']}>By clicking on this button {selectedPlan?.currency.symbol}{selectedPlan?.payable_price || selectedPlan?.amount_due} will be charged from your account.</p>
                            <ActionButton
                                kind='secondary_main'
                                loading={upgradeSubscriptionIsLoading}
                                onClick={() => { if (selectedPlan) changePlanHandler({ plan_id: selectedPlan.plan_id }); }}
                                disabled={!selectedPlan || upgradeSubscriptionIsLoading}
                                className={'w-100'}
                            >
                                Save and proceed to payment
                            </ActionButton>
                        </div>
                    </div>
                </>
            )}
            {isLoading && (
                <div className='d-flex justify-content-center py-5'>
                    <Spinner />
                </div>
            )}

        </div>
    );
};

export default ChangePlanModal;